"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantVirtualGraduationAssetState = exports.ParticipantVirtualGraduationState = void 0;
var ParticipantVirtualGraduationState;
(function (ParticipantVirtualGraduationState) {
    ParticipantVirtualGraduationState["New"] = "new";
    ParticipantVirtualGraduationState["Invited"] = "invited";
    ParticipantVirtualGraduationState["Submitted"] = "submitted";
    ParticipantVirtualGraduationState["Accepted"] = "accepted";
    ParticipantVirtualGraduationState["Rejected"] = "rejected";
    ParticipantVirtualGraduationState["Confirmed"] = "confirmed";
    ParticipantVirtualGraduationState["AdminConfirmed"] = "admin-confirmed";
})(ParticipantVirtualGraduationState = exports.ParticipantVirtualGraduationState || (exports.ParticipantVirtualGraduationState = {}));
var ParticipantVirtualGraduationAssetState;
(function (ParticipantVirtualGraduationAssetState) {
    ParticipantVirtualGraduationAssetState["NotAvailable"] = "notAvailable";
    ParticipantVirtualGraduationAssetState["ReadyToReview"] = "readyToReview";
    ParticipantVirtualGraduationAssetState["Accepted"] = "accepted";
    ParticipantVirtualGraduationAssetState["Rejected"] = "rejected";
})(ParticipantVirtualGraduationAssetState = exports.ParticipantVirtualGraduationAssetState || (exports.ParticipantVirtualGraduationAssetState = {}));
//# sourceMappingURL=participant-vg-state.js.map